import { BeforeLoadFn, redirect } from '@tanstack/react-router';

import { OneRosterAuth } from '@/components/auth/auth.context';
import { UserRoles } from '@/lib/constants/auth.constants.ts';

export const requireRole = (
  allowedRoles: UserRoles[]
): BeforeLoadFn<any, any, any, any, any> => {
  return async ({ context }) => {
    const auth = context.auth as OneRosterAuth;
    const roles = auth.user?.roles?.map((role: any) => role.role) ?? [];

    if (roles.includes(UserRoles.SYSTEM_ADMINISTRATOR)) {
      return; // bypass validation for system admins
    }

    const hasAllowedRole = allowedRoles.some((allowedRole) =>
      roles.includes(allowedRole)
    );

    if (!hasAllowedRole) {
      throw redirect({ to: '/app', replace: true });
    }
  };
};
